import {FC, useEffect, useState} from "react"
import Breadcrumb from "../../../components/common/Breadcrumbs";
import {useFindUserSettingsByGroupNameQuery} from "../../../components/common/userSetting/userSettingsApi";
import {useSearchSystemPropertiesQuery} from "./systemPropertiesApi";
import {createClickableLink} from "../../../components/common/datatable/DataTableUtils";
import {DataTable} from "../../../components/common/datatable/DataTable";
import {DataTableColumn} from "../../../components/common/datatable/DataTableTypes";
import IconButton from "../../../components/common/form/IconButton";
import {FaPlus} from "react-icons/fa";
import {useNavigate} from "react-router-dom";

const SystemProperties: FC = () => {
    const [crumbs] = useState([
        {content: "Home", url: "/home"},
        {content: "System Properties", url: ""},
    ])
    const navigate = useNavigate();
    const {data: userSettings} = useFindUserSettingsByGroupNameQuery("System Property");

    useEffect(() => {
        document.title = "System Properties";
    });

    const columns: DataTableColumn[] = [
        {
            label: "Name",
            accessor: "name",
            cell: (props: any) => {
                let path = `/system-properties/${props.row.original.id}`;
                return createClickableLink(path, props.value, userSettings, false, "", ["SPRO-R"]);
            },
            visibility:{hasShowSetting:false}
        },
        {label: "Value", accessor: "value"},
        {label: "Tenant", accessor: "tenant"},
    ]

    return (

        <div className="user-container px-4 py-2">
            <div className="flex justify-between mb-2.5">
                <Breadcrumb crumbs={crumbs}/>
            </div>

            <DataTable
                columns={columns}
                actions={{
                    fetchAction: useSearchSystemPropertiesQuery
                }}
                userSettingGroup={"System Property"}
                buttonOptions={{
                    addButton:
                        {
                            button: <IconButton
                                icon={<FaPlus/>}
                                className={'h-[36px]'}
                                hasBackground={true}
                                onClick={() => {
                                    navigate("/system-properties/create")
                                }}
                                title={"Add System Properties"}
                            />,
                            permissions: ["SPRO-C"]
                        },

                }}
                defaultSortOptions={{
                    accessor: "name",
                    direction: "asc"
                }}
                basePermission={"SPRO"}
            />
        </div>
    )
}
export default SystemProperties;